/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_Financing_MethodInputs */

const cs_investor_financing_method = /** @type {(inputs: Investor_Financing_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financování`)
};

const en_investor_financing_method = /** @type {(inputs: Investor_Financing_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financing`)
};

/**
* | output |
* | --- |
* | "Financing" |
*
* @param {Investor_Financing_MethodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_financing_method = /** @type {((inputs?: Investor_Financing_MethodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_Financing_MethodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_financing_method(inputs)
	return cs_investor_financing_method(inputs)
});